var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 38765"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 100",
    d: "M20.75 10.8515C20.75 16.2157 16.387 20.5683 11 20.5683C5.61298 20.5683 1.25 16.2157 1.25 10.8515C1.25 5.48735 5.61298 1.13477 11 1.13477C16.387 1.13477 20.75 5.48735 20.75 10.8515Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Orange"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 120",
    d: "M6.7656 14.8571L5.65971 9.70547C5.64268 9.62614 5.72224 9.56063 5.79683 9.59255L8.8541 10.9011C8.90242 10.9218 8.95851 10.9015 8.98246 10.8547L10.991 6.93116C11.0267 6.86127 11.1254 6.85798 11.1658 6.92533L13.5221 10.858C13.549 10.903 13.6062 10.9195 13.653 10.8959L16.2001 9.60838C16.2742 9.57091 16.3591 9.63494 16.3434 9.71652L15.3551 14.855C15.346 14.9021 15.3048 14.9362 15.2569 14.9362H6.86337C6.81623 14.9362 6.77549 14.9032 6.7656 14.8571Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminUsers);
export default __webpack_public_path__ + "static/media/admin_users.0dcd0a73eac852c7a9b3c8d1ef62e36c.svg";
export { ForwardRef as ReactComponent };